// @flow
export const APP_FLOW = Object.freeze({
  IM_NEW_HERE: 'IM_NEW_HERE',
  FIND_ME: 'FIND_ME',
  LOG_ME_IN: 'LOG_ME_IN',
  QUICK_APPT: 'IN_A_HURRY',
  IN_HURRY: 'IN_HURRY',
  /**
   * SignIn through a social provider
   */
  SOCIAL_SIGN_IN: 'SOCIAL_SIGN_IN',
  DEEP_LINK: 'DEEP_LINK'
});

export const CANCELLED = 'CANCELLED';



// WEBPACK FOOTER //
// ./src/constants/appFlow.js